/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
    namespaced: true,
    state: () => ({
        defaultColumns: {},
    }),
    mutations: {
        defaultColumns(state, payload) {
            var _a, _b;
            if (!((_a = state.defaultColumns) === null || _a === void 0 ? void 0 : _a[payload.userId])) {
                state.defaultColumns[payload.userId] = {};
            }
            if (!((_b = state.defaultColumns[payload.userId]) === null || _b === void 0 ? void 0 : _b[payload.reportId])) {
                state.defaultColumns[payload.userId][payload.reportId] =
                    {
                        columns: null,
                        projects: {},
                    };
            }
            // Project specific override
            if (payload.projectId) {
                state.defaultColumns[payload.userId][payload.reportId].projects[payload.projectId] = payload.columns;
            }
            // Global columns
            else {
                state.defaultColumns[payload.userId][payload.reportId] =
                    {
                        columns: payload.columns,
                        projects: {},
                    };
            }
        },
    },
    actions: {},
    getters: {
        defaultColumns(state) {
            return state.defaultColumns;
        },
        getDefaultColumnsForReport: (state) => (userId, reportId, projectId) => {
            var _a, _b, _c;
            if (!((_b = (_a = state.defaultColumns) === null || _a === void 0 ? void 0 : _a[userId]) === null || _b === void 0 ? void 0 : _b[reportId])) {
                return null;
            }
            const report = state.defaultColumns[userId][reportId];
            // Check project specific columns
            if ((_c = report === null || report === void 0 ? void 0 : report.projects) === null || _c === void 0 ? void 0 : _c[projectId]) {
                return report.projects[projectId];
            }
            // Return global columns
            return report.columns;
        },
    },
};
//# sourceMappingURL=reports.js.map